import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewChild,
  inject,
} from '@angular/core';
import { SharelockCommonModule } from '../../../../../share/modules/sharelock-common.module';
import {
  ENavigationUnitComponentSelection,
  INavigationDataTreeUnit,
} from '../../../../model/navigation.model';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import {
  AnimationStateE,
  SharelockAnimations,
} from '../../../../../share/utils/animations';
import { RouterModule } from '@angular/router';
import { IconComponent } from '../../../../../share/components/ui/icon/icon.component';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { NavigationButtonsBase } from '../../components/navigation-buttons/navigation-buttons.clsss';
import { TranslateService } from '@ngx-translate/core';
import { getLanguageAwareExternalUrl } from '../../../../../share/utils/external-url.utils';

@Component({
  selector: 'shrl-top-bar-navigation-buttons',
  imports: [
    SharelockCommonModule,
    MatRippleModule,
    MatIconModule,
    IconComponent,
    MatMenuModule,
    RouterModule,
  ],
  templateUrl: './top-bar-navigation-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [SharelockAnimations.rotate],
})
export class TopBarNavigationButtonsComponent extends NavigationButtonsBase {
  readonly isHorizontal = input(false);
  readonly #translate = inject(TranslateService);

  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

  constructor() {
    super(ENavigationUnitComponentSelection.TOPBAR);
    this.init();
  }

  getExternalUrl(externalUrl: string): string {
    return getLanguageAwareExternalUrl(externalUrl, this.#translate);
  }

  isActive = (navItem: INavigationDataTreeUnit) =>
    navItem.fullPath === '/' ? navItem.matchFullPath : navItem.matchPartialPath;

  getChildren = (navigationUnit?: INavigationDataTreeUnit) =>
    navigationUnit?.navigationChildren?.length
      ? navigationUnit.navigationChildren
      : undefined;

  readonly hasUnitChildren = (navigationUnit: INavigationDataTreeUnit) =>
    !!this.getChildren(navigationUnit)?.length;

  readonly menuTriggerToAnimationState = (menuTrigger: MatMenuTrigger) =>
    menuTrigger.menuOpen ? AnimationStateE.HIDE : AnimationStateE.SHOW;
}
